import * as ActionTypes from '~/actions/ActionTypes'
import { setReference } from '~/actions/timeline'
import { loadProject } from './loadProject'

export const initNewProject = () => async dispatch => {
  await dispatch(loadProject(null))
  await dispatch({
    type: ActionTypes.INSERT_LAYER,
    payload: { index: 0, isAdditional: true },
  })
  dispatch(setReference())
}
